<template>
  <div class="page">
    <p>请在微信客户端打开链接</p>
  </div>
</template>

<script>
export default {
  name: 'notWeixin',
  data() {
    return {
      //
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.page{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25rem;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// app/pages/notWeixin/notWeixin.vue